<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-start pa-2 pa-md-4>
      <v-flex xs12>
        <v-layout wrap justify-space-between align-center pb-4>
          <v-flex xs12 sm6 md4 lg3>
            <v-text-field
              v-model="searchQuery"
              color="#005f32"
              class="rounded-xl"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              hide-details
              label="Search..."
              clearable
              @keyup.enter="refreshData"
              @click:clear="clearSearch"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 text-right>
            <v-btn color="#005f32" dark @click="refreshData">
              <v-icon left>mdi-refresh</v-icon> Refresh
            </v-btn>
          </v-flex>
        </v-layout>

        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="#005f32"
          class="mb-4"
          @change="onTabChange"
        >
          <v-tab>Active Sessions</v-tab>
          <v-tab>History</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" style="background: transparent;">
          <v-tab-item>
            <v-layout wrap justify-start spacing-3>
              <v-flex
                xs12 sm6 md4 lg3
                v-for="(item, index) in auditLogList"
                :key="'active-' + index"
                pa-2
              >
                <v-card class="elevation-2 rounded-lg pa-4" style="height: 100%;">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <div class="font-weight-bold" style="color: #005f32; font-size: 16px;">
                      {{ item.employeeName }}
                    </div>
                    <v-chip small outlined color="green">
                      Active
                    </v-chip>
                  </div>
                  <div style="font-size: 12px; color: gray;" class="mb-3">
                    ID: {{ item.employeeId }}
                  </div>

                  <div class="mb-1" style="font-size: 13px;">
                    <v-icon small color="grey" class="mr-1">mdi-login</v-icon>
                    <strong>In:</strong> {{ item.loginTime }}
                  </div>
                  <div class="mb-3" style="font-size: 13px;">
                    <v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>
                    <strong>Last:</strong> {{ item.lastSeen }}
                  </div>

                  <v-btn
                    small
                    block
                    color="#005f32"
                    outlined
                    @click="openPagesModal(item)"
                  >
                    View Visited Pages ({{ item.pagesVisited.length }})
                  </v-btn>
                </v-card>
              </v-flex>
              <v-flex xs12 v-if="auditLogList.length === 0 && !appLoading" text-center py-10>
                <div style="color: gray; font-size: 18px;">No Active Sessions Found</div>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item>
            <v-layout wrap justify-start spacing-3>
              <v-flex
                xs12 sm6 md4 lg3
                v-for="(item, index) in auditLogList"
                :key="'history-' + index"
                pa-2
              >
                <v-card class="elevation-2 rounded-lg pa-4" style="height: 100%;">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <div class="font-weight-bold" style="color: #005f32; font-size: 16px;">
                      {{ item.employeeName }}
                    </div>
                    <v-chip small outlined color="red">
                      History
                    </v-chip>
                  </div>
                  <div style="font-size: 12px; color: gray;" class="mb-3">
                    ID: {{ item.employeeId }}
                  </div>

                  <div class="mb-1" style="font-size: 13px;">
                    <v-icon small color="grey" class="mr-1">mdi-login</v-icon>
                    <strong>In:</strong> {{ item.loginTime }}
                  </div>
                  <div class="mb-1" style="font-size: 13px;">
                    <v-icon small color="grey" class="mr-1">mdi-logout</v-icon>
                    <strong>Out:</strong> {{ item.logoutTime }}
                  </div>
                  <div class="mb-3" style="font-size: 13px;">
                    <v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>
                    <strong>Last:</strong> {{ item.lastSeen }}
                  </div>

                  <v-btn
                    small
                    block
                    color="#005f32"
                    outlined
                    @click="openPagesModal(item)"
                  >
                    View Visited Pages ({{ item.pagesVisited.length }})
                  </v-btn>
                </v-card>
              </v-flex>
              <v-flex xs12 v-if="auditLogList.length === 0 && !appLoading" text-center py-10>
                <div style="color: gray; font-size: 18px;">No History Logs Found</div>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>

        <v-layout wrap justify-center pt-5 v-if="pagelength > 0">
          <v-flex xs12 text-center>
            <v-pagination
              v-model="page"
              :length="pagelength"
              color="#005f32"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="pagesModal" max-width="600">
      <v-card>
        <v-card-title class="headline" style="background-color: #005f32; color: white;">
          Visited Pages
          <v-spacer></v-spacer>
          <v-btn icon dark @click="pagesModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-if="selectedLog">
            <v-data-table
              :headers="visitedPagesHeaders"
              :items="paginatedVisitedPages"
              :options.sync="visitedPagesOptions"
              :server-items-length="visitedPagesTotal"
              :loading="visitedPagesLoading"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:item.timestamp="{ item }">
                {{ formatDate(item.timestamp) }}
              </template>
            </v-data-table>
            <v-layout wrap justify-center pt-4 v-if="visitedPagesLength > 0">
              <v-flex xs12 text-center>
                <v-pagination
                  v-model="visitedPagesOptions.page"
                  :length="visitedPagesLength"
                  color="#005f32"
                ></v-pagination>
              </v-flex>
            </v-layout>
          </div>
          <div v-else class="text-center py-4">
            No pages visited yet.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      searchQuery: '',
      showsnackbar: false,
      msg: null,
      appLoading: false,
      tab: 0,
      page: 1,
      pagelength: 0,
      dataLimit: 12,
      auditLogList: [],
      pagesModal: false,
      selectedLog: null,
      visitedPagesHeaders: [
        { text: 'Page Name', value: 'pageName' },
        { text: 'Date & Time', value: 'timestamp' }
      ],
      visitedPagesOptions: {},
      visitedPagesTotal: 0,
      visitedPagesLength: 0,
      visitedPagesLoading: false,
      paginatedVisitedPages: []
    };
  },
  watch: {
    page() {
      this.getData();
    },
    visitedPagesOptions: {
      handler() {
        this.fetchVisitedPages();
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A";
      let d = new Date(dateString);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },
    openPagesModal(item) {
      this.selectedLog = item;
      this.pagesModal = true;
      this.fetchVisitedPages();
    },
    fetchVisitedPages() {
      if (!this.selectedLog || !this.selectedLog._id) return;
      this.visitedPagesLoading = true;
      const { page, itemsPerPage } = this.visitedPagesOptions;
      axios.post('/employee/audit/logs/pages', {
        logId: this.selectedLog._id,
        page: page || 1,
        limit: itemsPerPage && itemsPerPage > 0 ? itemsPerPage : 10
      }, {
        headers: { 'x-auth-token': localStorage.getItem("token") }
      }).then(res => {
        this.visitedPagesLoading = false;
        if(res.data && res.data.status) {
          this.paginatedVisitedPages = res.data.data;
          this.visitedPagesTotal = res.data.length;
          let limit = itemsPerPage && itemsPerPage > 0 ? itemsPerPage : 10;
          this.visitedPagesLength = Math.ceil((res.data.length || 0) / limit);
        } else {
          this.paginatedVisitedPages = [];
          this.visitedPagesTotal = 0;
          this.visitedPagesLength = 0;
        }
      }).catch(err => {
        this.visitedPagesLoading = false;
        console.error(err);
      });
    },
    onTabChange() {
      this.page = 1;
      this.getData();
    },
    clearSearch() {
      this.searchQuery = '';
      this.refreshData();
    },
    refreshData() {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.appLoading = true;
      let statusFilter = this.tab === 0 ? "active" : "history";
      
      axios.post('/employee/audit/logs', {
        page: this.page,
        limit: this.dataLimit,
        status: statusFilter,
        search: this.searchQuery
      }, {
        headers: { 'x-auth-token': localStorage.getItem("token") }
      })
      .then(res => {
         this.appLoading = false;
         if (res.data && res.data.status) {
             this.auditLogList = res.data.data.map(item => {
                 return {
                   _id: item._id,
                   employeeName: item.employeeId && item.employeeId.name ? item.employeeId.name : 'Unknown',
                   employeeId: item.employeeId && item.employeeId.employeeId ? item.employeeId.employeeId : 'N/A',
                   loginTime: this.formatDate(item.loginTime),
                   logoutTime: item.logoutTime ? this.formatDate(item.logoutTime) : 'N/A',
                   lastSeen: this.formatDate(item.lastSeen),
                   pagesVisited: item.pagesVisited || []
                 };
             });
             this.pagelength = Math.ceil((res.data.length || 0) / (res.data.limit || this.dataLimit));
         } else {
             this.msg = res.data.msg || "Failed to fetch data";
             this.showsnackbar = true;
             this.pagelength = 0;
             this.auditLogList = [];
         }
      })
      .catch(err => {
         this.appLoading = false;
         this.msg = "Server Error";
         this.showsnackbar = true;
         this.pagelength = 0;
         this.auditLogList = [];
         console.error(err);
      });
    },
  },
};
</script>

<style scoped>
.v-card {
  transition: box-shadow 0.3s;
}
.v-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}
</style>
